module.exports = {
  "country": "FI",
  "artist": "Erika Vikman",
  "song": "Ich komme",
  "year": "2025",
  "place": "11",
  "spotify": "52NFoPnzxOKPIcJIQ9mb5Q"
};